import React from 'react';
import Rally from '../Images/Rally.png';
import { Link } from 'react-router-dom';
import nav from '../JSON/NavFoot';

export default function Footer() {
    return (
        <div className='bg-[#ed5955] grid grid-cols-2 p-8 h-[40vh] md:h-[35vh] font-semibold'>
            <div className='grid grid-cols-1 md:grid-cols-2'>
                <Link to={nav[0].link}>
                    <span className='text-[4vw] md:text-[2vw]'>
                    {nav[0].title}
                    </span>
                </Link>
                <Link to={nav[1].link}>
                    <span className='text-[4vw] md:text-[2vw]'>
                    {nav[1].title}
                    </span>
                </Link>
                <Link to={nav[2].link}>
                    <span className='text-[4vw] md:text-[2vw]'>
                    {nav[2].title}
                    </span>
                </Link>
                <a href={nav[3].link}>
                    <span className='text-[4vw] md:text-[2vw]'>
                    {nav[3].title}
                    </span>
                </a>
            </div>
            <img src={Rally} className="md:h-32 ml-auto h-24" alt='Rally'/>
            <span className='text-[2vw] md:text-[1vw] pt-10'>© 2022 All Copyrights Reserved</span>
        </div>
    );

}